<template>
  <div class="section">
    <section>
      <div>
        <error-display-component :serverErrors="serverErrors" :serverErrorMessage="serverErrorMessage" id="error-container"></error-display-component>
      </div>
      <div v-show="isValidToken && !isLoading" class="hero">
        <div class="hero-body container container box has-background-white-bis">
          <div class="steps" id="stepsDemo">
            <div class="step-item is-active is-success">
              <div class="step-marker">1</div>
              <div class="step-details">
                <p class="step-title" style="text-decoration: none;" v-if="mobile">
                <i title="Vehicle" class="fal fa-car-alt fa-lg"></i>
                </p>
                <p class="step-title" v-else>VEHICLE</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-marker">2</div>
              <div class="step-details">
                <p class="step-title" style="text-decoration: none;" v-if="mobile">
                  <i title="Title Documents" class="fal fa-folder-open fa-lg"></i>
                </p>
                <p class="step-title" v-else>TITLE DOCUMENTS</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-marker">3</div>
              <div class="step-details">
                <p class="step-title" style="text-decoration: none;" v-if="mobile">
                  <i title="Images" class="fal fa-camera-retro fa-lg"></i>
                </p>
                <p class="step-title" v-else>IMAGES</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-marker">4</div>
              <div class="step-details">
                <p class="step-title" style="text-decoration: none;" v-if="mobile">
                  <i title="Windows Sticker" class="fal fa-money-check-edit fa-lg"></i>
                </p>
                <p class="step-title" v-else>WINDOW STICKER</p>
              </div>
            </div>
            <div class="step-item">
              <div class="step-marker">5</div>
              <div class="step-details">
                <p class="step-title" style="text-decoration: none;" v-if="mobile">
                  <i title="Terms" class="fal fa-file-signature fa-lg"></i>
                </p>
                <p class="step-title" v-else>TERMS</p>
              </div>
            </div>
          <div class="steps-content" id="steps-container">
            <form class="step-content has-text-centered is-active" data-vv-scope="step1">
              <section class="has-text-left">
                  <div class="credit-app has-background-grey-dark has-text-white">
                    Please complete your vehicle verification form
                  </div>
                  <div class="field">
                      <label class="label">Make</label>
                      <div class="control">
                          <input name="make" data-vv-as="make" v-validate="'max:250'" :class="{'input': true, 'is-danger': errors.has('step1.vehicleMakeName') }" type="text" placeholder="Make" v-model="vehicle.vehicleMakeName" :disabled="true">
                          <span v-show="errors.has('step1.vehicleMakeName')" class="help is-danger">
                          <i v-show="errors.has('step1.vehicleMakeName')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.vehicleMakeName') }}
                          </span>
                      </div>
                  </div>
                  <div class="field">
                      <label class="label">Model</label>
                      <div class="control">
                          <input name="vehicleModelName" data-vv-as="model" v-validate="'max:250'" :class="{'input': true, 'is-danger': errors.has('step1.vehicleModelName') }" type="text" placeholder="Model" v-model="vehicle.vehicleModelName" :disabled="true">
                          <span v-show="errors.has('step1.vehicleModelName')" class="help is-danger">
                          <i v-show="errors.has('step1.vehicleModelName')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.vehicleModelName') }}
                          </span>
                      </div>
                  </div>
                  <div class="field">
                      <label class="label">Production Year</label>
                      <div class="control">
                          <input name="vehicleProductionYear" data-vv-as="production year" v-validate="'max:250'" :class="{'input': true, 'is-danger': errors.has('step1.vehicleProductionYear') }" type="text" placeholder="Year" v-model="vehicle.vehicleProductionYear" :disabled="true">
                          <span v-show="errors.has('step1.vehicleProductionYear')" class="help is-danger">
                          <i v-show="errors.has('step1.vehicleProductionYear')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.vehicleProductionYear') }}
                          </span>
                      </div>
                  </div>
                  <div class="field">
                      <label class="label">Vin Number</label>
                      <div class="control">
                          <input name="vinNo" data-vv-as="vin number" v-validate="'max:250'" :class="{'input': true, 'is-danger': errors.has('step1.vinNo') }" type="text" placeholder="Vin Number" v-model="vehicle.vinNo" :disabled="true">
                          <span v-show="errors.has('step1.vinNo')" class="help is-danger">
                          <i v-show="errors.has('step1.vinNo')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.vinNo') }}
                          </span>
                      </div>
                  </div>
                  <div class="field" v-if="vehicle.trim">
                      <label class="label">Trim</label>
                      <div class="control">
                          <input name="trim" data-vv-as="trim" v-validate="'max:250'" :class="{'input': true, 'is-danger': errors.has('step1.trim') }" type="text" placeholder="Trim" v-model="vehicle.trim" :disabled="true">
                          <span v-show="errors.has('step1.trim')" class="help is-danger">
                          <i v-show="errors.has('step1.trim')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.trim') }}
                          </span>
                      </div>
                  </div>
                  <div class="field" v-if="vehicle.style">
                      <label class="label">Style</label>
                      <div class="control">
                          <input name="style" data-vv-as="style" v-validate="'max:250'" :class="{'input': true, 'is-danger': errors.has('step1.style') }" type="text" placeholder="Style" v-model="vehicle.style" :disabled="true">
                          <span v-show="errors.has('step1.style')" class="help is-danger">
                          <i v-show="errors.has('step1.style')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.style') }}
                          </span>
                      </div>
                  </div>
                  <div class="field">
                      <div class="field">
                      <label class="label">Miles</label>
                      <b-input type="text" v-model="vehicle.miles" v-cleave="mileageFormat" placeholder="Miles" name="miles" data-vv-as="miles" v-validate="'max:250'" :class="{'is-danger': errors.has('step1.miles') }" :disabled="true"></b-input>
                      <span v-show="errors.has('step1.miles')" class="help is-danger">
                        <i v-show="errors.has('step1.miles')" class="fas fa-exclamation-triangle"></i> {{ errors.first('step1.miles') }}
                      </span>
                    </div>
                  </div>
              </section>
            </form>
            <form class="step-content has-text-centered" data-vv-scope="step2">
              <section class="has-text-left">
                  <div class="credit-app has-background-grey-dark has-text-white">
                    Please upload the back and front title documents for this vehicle.
                  </div>
                <div class="is-full">
                  <div class="field is-full">
                    <file-selector v-model="titleFrontFiles" label="Front Image/Pdf" :multiple="false" :token="this.token" scope="step2" destinationUrl="/upload/receiveForInventory"></file-selector>
                  </div>
                  <div class="field is-full">
                    <file-selector v-model="titleBackFiles" label="Back Image/Pdf" :multiple="false" :token="this.token" scope="step2" destinationUrl="/upload/receiveForInventory"></file-selector>
                  </div>
                </div>
              </section>
            </form>
            <form class="step-content has-text-centered" data-vv-scope="step3">
                <div class="credit-app has-background-grey-dark has-text-white">
                  Please upload any images of this vehicle you may have available
                </div>
              <section class="has-text-left">
                <image-selector v-model="primaryImageFiles" label="" title="Vehicle Images" :token="this.token" scope="step3" destinationUrl="/upload/receiveForInventory"></image-selector>
              </section>
            </form>
            <form class="step-content has-text-centered" data-vv-scope="step4">
              <section class="has-text-left">
                <div class="credit-app has-background-grey-dark has-text-white">
                  Please upload any available window sticker documents for this vehicle.
                </div>
                <div class="is-full">
                  <div class="field is-full">
                    <file-selector v-model="windowStickerFiles" label="Front Image/Pdf" :multiple="false" :token="this.token" scope="step4" destinationUrl="/upload/receiveForInventory"></file-selector>
                  </div>
                </div>
              </section>
            </form>
            <div class="step-content has-text-centered">
              <div class="credit-app has-background-grey-dark has-text-white">
                Please review and accept the terms and conditions
              </div>
              <div v-observe-visibility="visibilityChanged">
                <div class="field">
                  <generic-terms-control v-model="vehicle.isTermsAccepted"></generic-terms-control>
                </div>
              </div>
            </div>
          </div>
          <div class="steps-actions">
            <div class="steps-action">
              <b-button icon-left="chevron-left" data-nav="previous" class="is-light" :disabled="hasSaved">Previous</b-button>
            </div>
            <div class="steps-action">
              <b-button icon-right="chevron-right" data-nav="next" class="next-step"  @click='nextStepCheck' :disabled="hasSaved">Next</b-button>
            </div>
            <div class="steps-action" v-if="termsVisible && canSave">
              <a class="button next-step" @click="save()" :disabled="hasSaved">Submit</a>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    <div v-show="!isValidToken && isLoading" class="hero">
      <div class="hero-body container">
        <div class="container is-fluid">
          <div class="columns is-vcentered loadingContainer">
            <div class="column is-12 has-text-centered has-text-weight-semi-bold">
              <img src="@/assets/ajax-loader.gif">
              <div v-if="!loadingBaseData">Verifying your identity....</div>
              <div v-if="loadingBaseData">Loading base data....</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isValidToken && !isLoading" class= "hero">
      <div class="hero-body container"></div>
    </div>
  </div>
</template>

<script>
import bulmaSteps from 'bulma-steps/dist/js/bulma-steps'
import supplierService from '@/services/supplierService'
import validateBeforeSubmitMixin from '@/mixins/generic/validateBeforeSubmit'
import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import { mapActions, createNamespacedHelpers } from 'vuex'
import FileSelector from '@/components/generic/FileSelector'
import utilitiesMixin from '@/mixins/generic/utilities'
import supplierMixin from '@/mixins/supplier/index'
import ImageSelector from '@/components/generic/ImageSelector'
import GenericTermsControl from '@/components/generic/GenericTermsControl'

const mapConfigGetters = createNamespacedHelpers('config').mapGetters

export default {
  name: 'SupplierVehicleVerification',
  inject: {
    $validator: '$validator'
  },
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  components: {
    'error-display-component': ErrorDisplayComponent,
    'file-selector': FileSelector,
    'image-selector': ImageSelector,
    'generic-terms-control': GenericTermsControl
  },
  mixins: [validateBeforeSubmitMixin, utilitiesMixin, supplierMixin],
  data () {
    return {
      mobile: window.innerWidth <= 700,
      isLoading: false,
      itemsHidden: false,
      currentStep: 0,
      termsVisible: false,
      isSaving: false,
      canSave: false,
      serverErrors: [],
      serverErrorMessage: '',
      isValidToken: false,
      preventClick: false,
      loadingBaseData: false,
      dealerId: 0,
      hasSaved: false,
      titleFrontFiles: [],
      titleBackFiles: [],
      primaryImageFiles: [],
      windowStickerFiles: [],
      supplierEmailValid: false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      currentUrl: '',
      isBankDetailsRequired: true,
      contacts: [],
      isPartial: 'required',
      isIcon: 'none',
      selectedAccountType: null,
      selectedDefaultMethod: null,
      vehicle: {
        subscriberId: 0,
        dealerId: 0,
        dealerName: '',
        name: '',
        stockNo: '',
        vinNo: '',
        vehicleProductionYear: '',
        vehicleMakeName: '',
        vehicleModelName: '',
        trim: '',
        style: '',
        miles: 0,
        isTermsAccepted: false,
        termsAcceptedAt: null,
        attributes: null,
        primaryImages: [],
        titleFront: {},
        titleBack: {},
        windowSticker: {},
        deletedImageIds: null,
        id: 0,
        createdAt: null,
        modifiedAt: null
      },
      socialSecurity: {
        delimiters: ['-', '-'],
        blocks: [3, 2, 4],
        numericOnly: true
      },
      phoneFormat: {
        numericOnly: true,
        blocks: [2, 3, 3, 4],
        prefix: '+1',
        delimiters: ['(', ')-', '-']
      },
      mileageFormat: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand'
      },
      titleLineOne: 'Test',
      titleLineTwo: 'Test2'
    }
  },
  computed: {
    ...mapConfigGetters(['definedTypes']),
    isTermsAccepted: function () {
      return this.vehicle.isTermsAccepted
    }
    // workhistory
  },
  methods: {
    ...mapActions(['updateReturnUrl', 'updateIsContinueLater']),
    fetchVehicleVerification: function (currentToken) {
      this.serverErrorMessage = ''
      this.loadingBaseData = true
      this.isLoading = true
      supplierService.getVehicleVerification(currentToken).then(response => {
        this.vehicle = {
          ...response.data.inventory
        }
        this.dealerId = this.vehicle.dealerId
        if (!this.dealerId || this.dealerId === 0) {
          this.serverErrorMessage = 'Could not retrieve vehicle information with code : ' + currentToken
        } else {
          this.isValidToken = true
          this.isLoading = false
          this.initInputValues()
        }
      // eslint-disable-next-line handle-callback-err
      }).catch((error) => {
        this.isLoading = false
        this.serverErrorMessage = 'Could not retrieve vehicle information with code: ' + currentToken
        this.isValidToken = false
      })
    },
    initInputValues () {
      if (this.vehicle != null) {
        if (this.vehicle.titleFront) {
          var titleFrontFile = {
            loaded: true,
            imageData: this.vehicle.titleFront.fileLocation,
            fileName: this.vehicle.titleFront.fileName,
            fileLocation: this.vehicle.titleFront.fileLocation,
            name: this.vehicle.titleFront.fileName,
            fileType: this.getFileType(this.vehicle.titleFront.fileLocation),
            id: this.vehicle.titleFront.id
          }

          this.titleFrontFiles.push(titleFrontFile)
        }
        if (this.vehicle.titleBack) {
          var titleBackFile = {
            loaded: true,
            imageData: this.vehicle.titleBack.fileLocation,
            fileName: this.vehicle.titleBack.fileName,
            fileLocation: this.vehicle.titleBack.fileLocation,
            name: this.vehicle.titleBack.fileName,
            fileType: this.getFileType(this.vehicle.titleBack.fileLocation),
            id: this.vehicle.titleBack.id
          }

          this.titleBackFiles.push(titleBackFile)
        }
        if (this.vehicle.primaryImages && this.vehicle.primaryImages.length > 0) {
          this.vehicle.primaryImages.forEach(element => {
            var primaryImageFile = {
              loaded: true,
              imageData: element.fileLocation,
              fileName: element.fileName,
              fileLocation: element.fileLocation,
              name: element.fileName,
              fileType: this.getFileType(element.fileLocation),
              id: element.id
            }

            this.primaryImageFiles.push(primaryImageFile)
          })
        }

        if (this.vehicle.windowSticker) {
          var windowStickerFile = {
            loaded: true,
            imageData: this.vehicle.windowSticker.fileLocation,
            fileName: this.vehicle.windowSticker.fileName,
            fileLocation: this.vehicle.windowSticker.fileLocation,
            name: this.vehicle.windowSticker.fileName,
            fileType: this.getFileType(this.vehicle.windowSticker.fileLocation)
          }

          this.windowStickerFiles.push(windowStickerFile)
        }
      } else {
        // console.log('initcomplete')
      }
    },
    visibilityChanged (isVisible, entry) {
      this.termsVisible = isVisible
    },
    evaluateRequiredTermsVisibility () {
      this.evaluateValidToSubmit()
    },
    evaluateValidToSubmit () {
      this.canSave = this.vehicle.isTermsAccepted
    },
    async nextStepCheck (e) {
      const stepScopes = ['step1', 'step2', 'step3', 'step4', 'step5']
      const currentStep = stepScopes[this.currentStep]
      const isValid = await this.$validator.validateAll(currentStep)
      this.preventClick = !isValid
    },
    onComplete () {
      this.$router.push({ name: 'SupplierVehicleVerificationComplete' })
    },
    resetVehicle () {
      this.vehicle = {
        subscriberId: 0,
        dealerId: 0,
        dealerName: '',
        name: '',
        stockNo: '',
        vinNo: '',
        vehicleProductionYear: '',
        vehicleMakeName: '',
        vehicleModelName: '',
        trim: '',
        style: '',
        miles: 0,
        isTermsAccepted: false,
        termsAcceptedAt: null,
        attributes: null,
        primaryImages: [],
        titleFront: {},
        titleBack: {},
        windowSticker: {},
        deletedImageIds: null,
        id: 0,
        createdAt: null,
        modifiedAt: null
      }
    },
    save () {
      var vehicleModel = {
        subscriberId: this.vehicle.subscriberId,
        dealerId: this.vehicle.dealerId,
        dealerName: this.vehicle.dealerName,
        name: this.vehicle.name,
        stockNo: this.vehicle.stockNo,
        vinNo: this.vehicle.vinNo,
        vehicleProductionYear: this.vehicle.vehicleProductionYear,
        vehicleMakeName: this.vehicle.vehicleMakeName,
        vehicleModelName: this.vehicle.vehicleModelName,
        trim: this.vehicle.trim,
        style: this.vehicle.style,
        miles: this.vehicle.miles,
        isTermsAccepted: this.vehicle.isTermsAccepted,
        termsAcceptedAt: new Date(),
        attributes: this.vehicle.attributes,
        primaryImages: [],
        titleFront: {},
        titleBack: {},
        windowSticker: {},
        deletedImageIds: '',
        id: this.vehicle.id,
        createdAt: this.vehicle.createdAt,
        modifiedAt: this.vehicle.modifiedAt,
        token: this.token
      }
      //
      this.hasSaved = true

      if (this.titleFrontFiles.length > 0) {
        var frontTitleFile = this.titleFrontFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uploadSize: x.size,
            uniqueId: x.uniqueId,
            type: 'Image',
            classType: 'TitleFront'
          }
        })
        if (frontTitleFile.length > 0) {
          vehicleModel.titleFront = frontTitleFile[0]
        } else {
          vehicleModel.titleFront = this.vehicle.titleFront
        }
      }

      if (this.titleBackFiles.length > 0) {
        var backTitleFile = this.titleBackFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uploadSize: x.size,
            uniqueId: x.uniqueId,
            type: 'Image',
            classType: 'TitleBack'
          }
        })
        if (backTitleFile.length > 0) {
          vehicleModel.titleBack = backTitleFile[0]
        } else {
          vehicleModel.titleBack = this.vehicle.titleBack
        }
      }

      if (this.primaryImageFiles.length > 0) {
        var primaryFiles = this.primaryImageFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uploadSize: x.size,
            uniqueId: x.uniqueId,
            type: 'Image',
            classType: 'Primary'
          }
        })

        vehicleModel.primaryImages.push(...primaryFiles)
      }
      var removedImages = this.vehicle.primaryImages.filter(a => !this.primaryImageFiles.some(b => a.id === b.id))
      if (removedImages.length > 0) {
        const result = removedImages.map(a => a.id)
        const deletedImages = result.join(',')
        vehicleModel.deletedImageIds = deletedImages
      }

      if (this.windowStickerFiles.length > 0) {
        var stickerFiles = this.windowStickerFiles.filter((y) => !y.id || y.id <= 0).map((x) => {
          return {
            uploadName: x.name,
            uploadSize: x.size,
            uniqueId: x.uniqueId,
            type: 'Image',
            classType: 'WindowSticker'
          }
        })

        vehicleModel.windowSticker = stickerFiles[0]
      }
      this.isSaving = true
      this.serverErrorMessage = ''
      this.serverErrors = []

      supplierService.vehicleVerification(vehicleModel).then(response => {
        this.isSaving = false
        if (response.errors) {
          this.serverErrors = response.errors
          this.$nextTick(function () {
            var elmnt = document.getElementById('main-page')
            elmnt.scrollTo(0, 0)
          })
          this.hasSaved = false
        } else {
          this.$emit('on-save', response)
          this.onChangesSaved()
          this.onComplete()
          this.hasSaved = false
        }
      }).catch((error) => {
        this.serverErrorMessage = error.message
        this.isSaving = false
        this.$nextTick(function () {
          var elmnt = document.getElementById('main-page')
          elmnt.scrollTo(0, 0)
        })
        this.hasSaved = false
      })
    },
    checkRemoveButtonVisibility (dataCollection) {
      if (dataCollection.length > 1) {
        return true
      }
      return false
    }
  },
  created () {
    this.currentUrl = window.location.href
    this.$emit('is-home', false)
  },
  mounted () {
    bulmaSteps.attach('.steps', {
      beforeNext: id => {
        var beforeNextResult = {}
        if (this.preventClick) {
          beforeNextResult.errors = ['Error occured']
          return beforeNextResult
        } else {
          return beforeNextResult
        }
      },
      beforePrevious: id => {
        this.currentStep = id
      },
      onShow: id => {
        var elmnt = document.getElementById('main-page')
        elmnt.scrollTo(0, 0)
        this.currentStep = id
      }
    })
    this.resetVehicle()
    this.fetchVehicleVerification(this.token)
    this.$emit('set-title-one', 'VEHICLE')
    this.$emit('set-title-two', 'VERIFICATION')
  },
  watch: {
    isTermsAccepted () {
      this.evaluateValidToSubmit()
    },
    token: function (newValue, oldValue) {
      this.isValidToken = false
      this.fetchVehicleVerification(this.token)
    }
  }
}

</script>

<style scoped>

</style>
